const SERVER_NEW_PATH = '/new';

/**
 * Whether a post-auth destination is the server's `/new` endpoint — where the
 * dates.new domain drops people, with nothing on the page to explain why they
 * are suddenly being asked to sign in.
 *
 * `useFrom` normalises every way in (`?new=1`, `?from=/new`, and either of those
 * carrying a `templateId`) down to this one path, so matching the resolved
 * destination covers them all.
 */
export const isDatesNewDestination = (
  destination: string | undefined
): boolean => {
  if (!destination) return false;

  const [pathname] = destination.split('?');
  return pathname === SERVER_NEW_PATH;
};
